import React from "react";

import { BackHandler, Image, Text, TouchableOpacity, View } from "react-native";
import { connect } from "react-redux";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

import { getBaseUrl } from "../helpers/storage";

class PreAssessmentScreen extends React.Component {
  componentDidMount() {
    this.backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      this.handleBackPress
    );
  }

  componentWillUnmount() {
    this.backHandler.remove();
  }

  handleBackPress = () => {
    return true;
  };

  async submit(result) {
    const { token } = this.props;

    await fetch(getBaseUrl() + "consultations/pre-assessment", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      method: "POST",
      body: JSON.stringify({
        result: result
      })
    });

    this.props.navigation.goBack();
  }

  render() {
    const { themeColors } = this.props;
    const { doctor } = this.props.navigation.state.params;

    return (
      <View style={{ backgroundColor: themeColors.primary, flex: 1 }}>
        <View
          style={{
            alignItems: "center",
            flexGrow: 1,
            justifyContent: "center"
          }}
        >
          <Image
            source={{
              uri: doctor.avatarUrl
            }}
            style={{
              borderColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: 110,
              borderWidth: 10,
              height: 220,
              marginBottom: 40,
              width: 220
            }}
          />
          <Text
            style={{
              color: staticColors.white,
              fontSize: 16,

              ...fonts.regular
            }}
          >
            Konsultasi Anda akan terhubung dengan
          </Text>
          <Text
            style={{ color: staticColors.white, fontSize: 24, ...fonts.bold }}
          >
            {doctor.fullName}
          </Text>
        </View>
        <View
          style={{
            backgroundColor: staticColors.white,
            borderTopEndRadius: 40,
            borderTopStartRadius: 40,
            padding: 25
          }}
        >
          <Text
            style={{
              color: staticColors.cavernous,
              fontSize: 24,
              marginBottom: 15,
              textAlign: "center",

              ...fonts.bold
            }}
          >
            Survey Singkat
          </Text>
          <Text
            style={{
              color: staticColors.grey,
              fontSize: 16,
              marginBottom: 30,
              textAlign: "center",

              ...fonts.regular
            }}
          >
            Sebelum memulai konsultasi, apakah Anda sebelumnya sudah ada rencana
            untuk datang ke rumah sakit/klinik untuk rawat jalan?
          </Text>
          <View
            style={{ flexDirection: "row", justifyContent: "space-around" }}
          >
            <TouchableOpacity
              onPress={() => this.submit(false)}
              style={{
                backgroundColor: staticColors.thimbleberry,
                borderRadius: 20,
                paddingHorizontal: 30,
                paddingVertical: 10
              }}
            >
              <Text
                style={{
                  color: staticColors.white,
                  fontSize: 16,

                  ...fonts.bold
                }}
              >
                Tidak
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => this.submit(true)}
              style={{
                backgroundColor: staticColors.forestFern,
                borderRadius: 20,
                paddingHorizontal: 30,
                paddingVertical: 10
              }}
            >
              <Text
                style={{
                  color: staticColors.white,
                  fontSize: 16,

                  ...fonts.bold
                }}
              >
                Ya
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  }
}

export default connect(state => ({
  themeColors: state.themeColors,
  token: state.token
}))(PreAssessmentScreen);
